<template>
  <div>
    <v-btn @click="createPPT()" :disabled="disableBtn" class="ml-5">PPTX EN</v-btn>
  </div>
</template>

<script>
import defaultSlide from "@/mixin/defaultSlide";
import { mapGetters } from "vuex";
import FirstPageRectangle from "@/json/PowerPoint/FirstPageRectangle.json";
import FontFirstPageHeader from "@/json/PowerPoint/FontFirstPageTitle.json";
import FontLegendaHead from "@/json/PowerPoint/FontLegendaHead.json";
import FontLegendaText from "@/json/PowerPoint/FontLegendaText.json";
import FontLegendaTextBlock from "@/json/PowerPoint/FontTextBlock.json";
import FontLegendaTextBlockXL from "@/json/PowerPoint/FontTextBlockXL.json";
import FontTitleBig from "@/json/PowerPoint/FontTitleBig.json";
import FontTitleSmall from "@/json/PowerPoint/FontTitleSmall.json";
import GraphChart from "@/json/PowerPoint/GraphChart.json";
import PlaceFirstPageTitle from "@/json/PowerPoint/PlaceFistPageTitle.json";
import PlaceLegenda from "@/json/PowerPoint/PlaceLegenda.json";
import PlaceTextBlock from "@/json/PowerPoint/PlaceTextBlock.json";
import PlaceTextBlockXL from "@/json/PowerPoint/PlaceTextBlockXL.json";
import TitlePlace from "@/json/PowerPoint/PlaceTitle.json";
import TableOptions from "@/json/PowerPoint/TableOptions.json";
import TableOptionsRemark from "@/json/PowerPoint/TableOptionsRemark.json";
import FontFirstPageSubHeader from "@/json/PowerPoint/FontFirstPageSubHeader.json";
import FontFirstPageThreeHeader from "@/json/PowerPoint/FontFirstPageThreeHeader.json";
import PlaceFirstPageSubHeader from "@/json/PowerPoint/PlaceFirstPageSubHeader.json";
import PlaceFirstPageThreeHeader from "@/json/PowerPoint/PlaceFirstPageThreeHeader.json";
import textA from "@/json/Fchart/Report/en/textE_en.json";
import FchartService from "@/services/fchart/FchartService";
export default {
  name: "EnReportE",
  components: {},
  mixins: [defaultSlide],

  data() {
    return {
      disableBtn: false,
      textModule: textA,
      firstPageRectangle: FirstPageRectangle,
      fontFirstPageHeader: FontFirstPageHeader,
      LegendaKop: FontLegendaHead,
      LegendaTekst: FontLegendaText,
      TextBlock: FontLegendaTextBlock,
      TextBlockXL: FontLegendaTextBlockXL,
      gTitle: FontTitleBig,
      gTitleSmall: FontTitleSmall,
      optionsGraph: GraphChart,
      placeFirstPageTitle: PlaceFirstPageTitle,
      TextBlockLegenda: PlaceLegenda,
      TextBlockPlace: PlaceTextBlock,
      TextBlockPlaceXL: PlaceTextBlockXL,
      gTitlePlace: TitlePlace,
      optTable: TableOptions,
      optTableRemark: TableOptionsRemark,
      placeFirstPageThreeHeader: PlaceFirstPageThreeHeader,
      placeFirstPageSubHeader: PlaceFirstPageSubHeader,
      fontFirstPageSubHeader:FontFirstPageSubHeader,
      fontFirstPageThreeHeader: FontFirstPageThreeHeader,
      dataext: null,
    };
  },
  methods: {
    getData() {
      let id = this.$route.params.famId;
      this.loading = true;
      FchartService.getMain(id)
        .then((response) => {
          this.dataext = response.data.data;
        })
        .finally(() => (this.loading = false));
    },

    createPPT() {
      // eslint-disable-next-line no-undef
      let pres = new pptxgen();
      this.disableBtn = true;
      // eslint-disable-next-line no-undef
      EventBus.$emit("print", true);


      // deenition variables
      let k = this.estoremodules.length;
      let l = k - 1;
      let namen = [];

      // special multiple choise

      // remarks
      let remarkDataA = [];
      let remarkDataB = [];
      let remarkDataG = [];
      let remarkDataH = [];

      for (let m = 0; m <= l; m++) {
        namen.push(this.estoremodules[m].first_name);
        remarkDataA.push(this.estoremodules[m].efsmodule.question_a);
        remarkDataB.push(this.estoremodules[m].efsmodule.question_b);
        remarkDataG.push(this.estoremodules[m].efsmodule.question_g);
        remarkDataH.push(this.estoremodules[m].efsmodule.question_h);
      }
      ///slider

      //remarks
      let arrayRemarkA = [namen, remarkDataA, remarkDataB, remarkDataG, remarkDataH];

      pres.defineSlideMaster(this.data);
      pres.defineSlideMaster(this.data2);
      pres.defineSlideMaster(this.data3);

      let slide1 = pres.addSlide("FIRST_SLIDE");
      slide1.addShape(pres.ShapeType.rect, this.firstPageRectangle);
      slide1.addText([{ text: "Family charter", options: this.fontFirstPageHeader }], this.placeFirstPageTitle);
      slide1.addText([{ text: this.textModule[0].header, options: this.fontFirstPageSubHeader }], this.placeFirstPageSubHeader);
      slide1.addText([{ text: "Family " + this.dataext.family_name, options: this.fontFirstPageThreeHeader }], this.placeFirstPageThreeHeader);
      let slide2 = pres.addSlide("MASTER_SLIDE");
      slide2.addText([{ text: this.textModule[0].header, options: this.gTitle }], this.gTitlePlace);
      slide2.addText(
        [
          { text: this.textModule[0].texta, options: this.TextBlockXL },
          { text: "", options: this.TextBlockXL },
          { text: this.textModule[0].textb, options: this.TextBlockXL },
          { text: "", options: this.TextBlockXL },
          { text: this.textModule[0].textc, options: this.TextBlockXL },
          { text: "", options: this.TextBlockXL },
          { text: this.textModule[0].textd, options: this.TextBlockXL },
        ],
        this.TextBlockPlaceXL
      );

      let slide4 = pres.addSlide("MASTER_SLIDE");
      slide4.addText([{ text: "Overview of family values", options: this.gTitle }], this.gTitlePlace);
      slide4.addTable(arrayRemarkA, this.optTableRemark);

      let filename = "Report_" + this.textModule[0].header + "_" + this.dataext.family_name + ".pptx";
      // eslint-disable-next-line no-undef
      pres.writeFile({ fileName: filename });
      this.disableBtn = false;
    },
  },
  computed: {
    ...mapGetters("fchartEresult", ["estoremodules"]),
    ...mapGetters("colors", ["colors"]),
    ...mapGetters("emain", ["statements"]),
  },
  created() {
    this.$store.dispatch("emain/getMains");
    this.getData();
  },
};
</script>

<style scoped></style>
